export default "__VITE_ASSET__Clrv8pjJ__"